import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const TileLink = createComponent('a', {
  className: cx(
    'flex flex-col gap-xl p-xl w-full relative',
    'rounded-md border border-border-weak bg-background-default',
    'cursor-pointer select-none no-underline text-inherit',
    'hover:bg-background-weak hover:border-border-default',
    'active:border-border-strong',
    'pointer-coarse:active:bg-background-default pointer-coarse:active:border-border-weak',
    'focus-visible:outline focus-visible:outline-1 focus-visible:outline-[#228be6]',
    'focus-visible:outline-offset-0 focus-visible:shadow-focusvisible'
  )
});
